var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenalties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M400,245c-85.6,0-155,69.4-155,155s69.4,155,155,155,155-69.4,155-155-69.4-155-155-155ZM322.5,400c0-42.8,34.7-77.5,77.5-77.5s77.5,34.7,77.5,77.5-34.7,77.5-77.5,77.5-77.5-34.7-77.5-77.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M400,90c-171.21,0-310,138.79-310,310s138.79,310,310,310,310-138.79,310-310S571.21,90,400,90ZM167.5,400c0-128.41,104.09-232.5,232.5-232.5s232.5,104.09,232.5,232.5-104.09,232.5-232.5,232.5-232.5-104.09-232.5-232.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenalties);
export default __webpack_public_path__ + "static/media/penalties.27cf0ebe.svg";
export { ForwardRef as ReactComponent };